<script setup lang="ts">
  import { LoaderCircle } from 'lucide-vue-next'
  import { useRoute } from 'vue-router'
  import { computed, onMounted, ref, watch } from 'vue'
  import { useClientActionStore } from '@/store/clientActionStore'
  import { genericErrorToast } from '@/lib/toasts'
  import client404 from '@/components/404/404.vue'
  import { useMetrics, MetricEventType } from '@/composables/useMetrics'
  import ClientPortal from '@/components/clientPortal/clientPortal.vue'
  const route = useRoute()
  const clientActionsStore = useClientActionStore()
  const { trackEvent } = useMetrics()

  const accessToken = computed(() => route.query.access_token as string | undefined)
  const isDataLoaded = ref(false)

  const clientAction = computed(() => clientActionsStore.getClientAction)

  if (accessToken.value) {
    clientActionsStore.setAccessToken(accessToken.value)
  }

  watch(accessToken, (newToken: any) => {
    if (newToken) {
      clientActionsStore.setAccessToken(newToken)
    }
  })

  onMounted(async () => {
    // Skip data fetching for preview routes
    if (route.path.includes('/preview/')) {
      isDataLoaded.value = true
      return
    }

    try {
      const status = await clientActionsStore.fetchClientActions()

      if (status !== 200) {
        genericErrorToast()
      }

      isDataLoaded.value = true
    } catch (error) {
      genericErrorToast()
    }

    trackEvent(MetricEventType.CLIENT_HOME, {
      organization_id: clientActionsStore?.getClientAction?.org_id
    })
  })
</script>

<template>
  <div class="">
    <!-- Only render the content if data is loaded -->
    <div v-if="isDataLoaded">
      <!-- Conditionally render the clientPortal components if clientAction is not null -->
      <div v-if="clientAction">
        <ClientPortal />
      </div>

      <!-- Render the client404 component if clientAction is null -->
      <client404 v-else />
    </div>

    <!-- Render the LoaderCircle component if data is not loaded yet -->
    <div
      v-else
      class="flex h-screen items-center justify-center"
    >
      <LoaderCircle
        class="animate-spin"
        :size="100"
      />
    </div>
  </div>
</template>
